/* eslint-disable ember/no-controller-access-in-routes, ember/no-get, warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { get } from '@ember/object';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class TopicRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    let store = this.store;
    let group = this.modelFor('group');

    return hash({
      group,
      // Load all subjects, categories, subcategories, and goals into the model
      subjects: store.findAll('goals/subject'),
      categories: store.findAll('goals/category'),
      subcategories: store.findAll('goals/subcategory'),
      goals: store.findAll('goals/goal'),
      // Load the specific goal based on `goal_id`
      currentGoal: store
        .findRecord('goals/goal', params.goal_id)
        .then((goal) => {
          // Access the pre-combined goals list from the model
          const combinedGoalIds = goal.combinedGoals.map((g) => g.id);

          // Fetch states for each unique `goalId`, including the root goal
          return hash({
            goal,
            states: Promise.all([
              // Fetch states for the root goal
              store
                .query('goals/state', {
                  goalId: goal.id, // Root goal's ID
                  current: true,
                  groupId: group.id,
                })
                .catch(() => []),
              // Fetch states for combined goals
              ...combinedGoalIds.map((goalId) =>
                store
                  .query('goals/state', {
                    goalId,
                    current: true,
                    groupId: group.id,
                  })
                  .catch(() => []),
              ),
            ]).then((statesArray) => statesArray.flat()), // Flatten the array of states
          });
        })
        .catch(() => null), // Fallback to null if `currentGoal` fetch fails
    });
  }

  setupController(controller, model) {
    super.setupController(controller, model);

    // Set the active tab.
    this.controllerFor('group.topics').set(
      'tab',
      get(model, 'currentGoal.goal.subject.id'),
    );
  }
}
